import { useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

export const RANGE_OPTIONS = [
  { value: '7d', label: '7 days' },
  { value: '30d', label: '30 days' },
  { value: '90d', label: '90 days' },
  { value: '12m', label: '12 months' },
  { value: 'custom', label: 'Custom' },
];

/**
 * Filter bar: date range, product, customer ID and the test-account switch.
 * Customer ID is applied on Enter or when the field loses focus, so typing doesn't fire a request per keystroke.
 */
export default function DashboardFilters({ filters, productOptions, onChange }) {
  const { range, customFrom, customTo, product, customer, excludeTest } = filters;
  const [customerDraft, setCustomerDraft] = useState(customer);

  // Keep the text box in sync when the customer is set elsewhere (clicking a top-10 bar).
  useEffect(() => setCustomerDraft(customer), [customer]);

  const applyCustomer = () => {
    const v = customerDraft.trim();
    if (v !== customer) onChange({ customer: v });
  };

  return (
    <Stack direction="row" sx={{ flexWrap: 'wrap', alignItems: 'center', gap: 1.5 }}>
      <ToggleButtonGroup
        size="small"
        exclusive
        value={range}
        onChange={(_, v) => v && onChange({ range: v })}
        aria-label="Date range"
        sx={{ bgcolor: 'background.paper' }}
      >
        {RANGE_OPTIONS.map((r) => (
          <ToggleButton key={r.value} value={r.value} sx={{ px: 1.75, textTransform: 'none' }}>
            {r.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>

      {range === 'custom' && (
        <>
          <TextField
            size="small" type="date" label="From" value={customFrom}
            onChange={(e) => e.target.value && onChange({ customFrom: e.target.value })}
            InputLabelProps={{ shrink: true }} sx={{ bgcolor: 'background.paper' }}
          />
          <TextField
            size="small" type="date" label="To" value={customTo}
            onChange={(e) => e.target.value && onChange({ customTo: e.target.value })}
            InputLabelProps={{ shrink: true }} sx={{ bgcolor: 'background.paper' }}
          />
        </>
      )}

      <TextField
        select size="small" label="Product" value={product}
        onChange={(e) => onChange({ product: e.target.value })}
        sx={{ minWidth: 220, bgcolor: 'background.paper' }}
      >
        <MenuItem value="">All products</MenuItem>
        {productOptions.map((p) => (
          <MenuItem key={p} value={p}>{p}</MenuItem>
        ))}
      </TextField>

      <TextField
        size="small" label="Customer ID" value={customerDraft}
        onChange={(e) => setCustomerDraft(e.target.value)}
        onBlur={applyCustomer}
        onKeyDown={(e) => e.key === 'Enter' && applyCustomer()}
        sx={{ width: 160, bgcolor: 'background.paper' }}
      />

      <FormControlLabel
        control={<Switch checked={excludeTest} onChange={(e) => onChange({ excludeTest: e.target.checked })} />}
        label="Exclude GMMI and test accounts"
      />
    </Stack>
  );
}
